import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import {
  Button,
  FormControl,
  Modal,
  TextField,
} from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { SelectCargoGrupo } from "../../../../components/selects/cargoGrupo";
import { SelectCargo } from "../../../../components/selects/cargo";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import useLoading from "../../../../hooks/useLoading";
import api from "../../../../utils/api";
import { useParams } from "react-router-dom";
import { AtividadeGeral } from "../../../../types";
import { useEffect } from "react";


export const AtividadeEdit = () => {
  const { goBack } = useNav();
  const { id } = useParams();
  const { setMensagemError, setMensagemInfo, setMensagemSuccess } =
    useErrorSuccess();

  const { startLoading, stopLoading, isLoading } = useLoading();

  const getAtividade = async () => {
    try {
      let atividade = await api.get<AtividadeGeral>("atividade/geral/" + id).then(res => res?.data);
      setValue('descricao', atividade?.descricao);
      setValue('grupo', atividade?.grupo);
      setValue('cargo', atividade?.cargo);
    } catch (error) {
      setMensagemInfo('Atividade não encontrada')
    } finally {
    }
  };

  const { register, watch, setValue, handleSubmit } = useForm<{
    descricao: string;
    grupo: number;
    cargo: number;
  }>({
    defaultValues: {
      descricao: null,
      cargo: null,
      grupo: null,
    },
  });

  useEffect(() => {
    getAtividade();
  }, [])

  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put('atividade/geral/'+id, values);
      setMensagemSuccess('Alterado com Sucesso!');
      goBack();
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data?.mensagem, null, 2) || 'Erro ao alterar atividade!')
    } finally {
      stopLoading();
    }
  })


  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal props={{ display: "grid", rowGap: 1 }}>
          <FormControl fullWidth>
            <TextField
              {...register("descricao")}
              label="Descrição"
              sx={{ width: "100%" }}
            />
          </FormControl>
          <SelectCargoGrupo
            action={(grupo) => {
              setValue("grupo", grupo?.target?.value);
            }}
            valor={watch("grupo")}
          />
          <SelectCargo
            titulo="Cargo"
            action={(cargo) => {
              setValue("cargo", cargo?.target?.value);
            }}
            valor={watch("cargo")}
          />
          <div
            style={{
              display: "flex",
              marginTop: 8,
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button variant="contained" onClick={put} disabled={isLoading}>Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>
              Cancelar
            </Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  );
};
